module.exports = __webpack_public_path__ + "img/logo.6d9a6414.png";